import {
  DEFAULT_PAGE_SIZE,
  FilteredTablePayload,
  TableColumns,
  TableFilterTab,
} from '@kuiper/ibusiness-core';

export const BACKGROUND_TASK_COLUMNS: TableColumns[] = [
  { header: '', identifier: 'number' },
  {
    header: 'background_task_list_code_column',
    identifier: 'code',
    isSortable: true,
    sortKey: 'id',
    showViewIcon: true,
  },
  { header: 'background_task_list_type_column', identifier: 'type' },
  { header: 'background_task_list_input_column', identifier: 'input' },
  { header: 'background_task_list_state_column', identifier: 'state' },
  { header: 'background_task_result_created_label', identifier: 'created' },
  { header: 'background_task_result_skipped_label', identifier: 'skipped' },
  {
    header: 'background_task_list_uploaded_at_column',
    identifier: 'created_at',
    isSortable: true,
    sortKey: 'created_at',
  },
];

export const BACKGROUND_TASK_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    label: 'background_task_list_filter_all',
    active: true,
    iconName: 'all',
  },
  {
    key: 'in_progress',
    label: 'background_task_list_filter_processing',
    active: false,
    iconName: 'inprogress',
  },
  {
    key: 'completed',
    label: 'background_task_list_filter_completed',
    active: false,
    iconName: 'completed',
  },
  {
    key: 'failed',
    label: 'background_task_list_filter_failed',
    active: false,
    iconName: 'rejected',
  },
];

export const BACKGROUND_TASK_DEFAULT_PAYLOAD: FilteredTablePayload = {
  page: 1,
  size: DEFAULT_PAGE_SIZE,
  search: '',
  filters: {},
  sortColumn: { key: '', value: 'asc' },
  tab: BACKGROUND_TASK_FILTER_TABS[0],
};

/** A tab can stand for several states: a task waits as pending until a worker picks it up. */
export const STATES_BY_TAB: Record<string, string[]> = {
  all: [],
  in_progress: ['pending', 'processing'],
  completed: ['completed'],
  failed: ['failed'],
};

/** Same colors as the shared status pipe, which has no processing / failed states. */
export const STATE_BADGE: Record<string, string> = {
  pending: 'bg-warning-500 text-white',
  processing: 'bg-warning-500 text-white',
  completed: 'bg-success-500 text-white',
  failed: 'bg-destructive-500 text-white',
};
